// extracted by mini-css-extract-plugin
module.exports = {"root":"TitleWithDescription_root__3uP0l","title":"TitleWithDescription_title__2KMUU","description":"TitleWithDescription_description__24mps"};